import { gql } from "@apollo/client";
import { LEGACY_TERM_SHEET_FIELDS } from "graphql/fragments";

const GET_LEGACY_TERM_SHEETS = gql`
  ${LEGACY_TERM_SHEET_FIELDS}
  query getLegacyTermSheets($teamId: ID!) {
    legacyTermSheets(teamId: $teamId) {
      buyInCurrency
      sellInCurrency
      nodes {
        ...LegacyTermSheetFields
      }
    }
  }
`;

export { GET_LEGACY_TERM_SHEETS };
